/**
 * Created by gary on 18/05/2017.
 */

const getAPIPath = () => {
    const pathname = window.location.host.toLowerCase();
    let apiUrl = '/';

    if (pathname.indexOf('thecoachingmanual.com') > -1) {
        apiUrl = 'https://api.thecoachingmanual.com/';
    } else if (pathname.indexOf('thecoachingmanual.local') > -1) {
        apiUrl = 'https://api.thecoachingmanual.local/';
    } else if (pathname.indexOf('beans.youballer.io') > -1) {
        apiUrl = 'https://api.beans.youballer.io/';
    } else if (pathname.indexOf('localhost') > -1) {
        apiUrl = 'http://localhost:15004/';
    } else {
        apiUrl = '/';
    }

    return apiUrl;
};

export default getAPIPath();



// WEBPACK FOOTER //
// ./library/js/modules/api-location.js